// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cardElem_wrapper__nktft","card":"cardElem_card__3OsiW","available":"cardElem_available__nzzvG"};